<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-4">
      <div>
        <div class="text-muted small text-uppercase font-weight-bold">CMS</div>
        <h2 class="h4 font-weight-bold text-primary mb-0">Quản lý bài viết</h2>
      </div>
      <b-button variant="primary" pill @click="openCreateModal">Tạo bài viết</b-button>
    </div>

    <div class="admin-card bg-white p-4">
      <b-table :items="posts" :fields="fields" responsive>
        <template #cell(thumbnail)="row">
          <img :src="resolveAssetUrl(row.item.thumbnail)" alt="Thumbnail" class="rounded" style="width: 80px; height: 56px; object-fit: cover;">
        </template>
        <template #cell(status)="row">
          <b-badge :variant="row.item.status ? 'success' : 'secondary'">
            {{ row.item.status ? "Hiển thị" : "Ẩn" }}
          </b-badge>
        </template>
        <template #cell(createdAt)="row">
          {{ formatDate(row.item.createdAt) }}
        </template>
        <template #cell(actions)="row">
          <div class="d-flex">
            <b-button size="sm" variant="outline-primary" class="mr-2" @click="openEditModal(row.item)">Sửa</b-button>
            <b-button size="sm" variant="outline-danger" @click="removePost(row.item)">Xóa</b-button>
          </div>
        </template>
      </b-table>
    </div>

    <b-modal id="post-modal" v-model="showModal" size="xl" title="Bài viết" hide-footer>
      <b-form @submit.prevent="savePost">
        <div class="row">
          <div class="col-lg-8">
            <b-form-group label="Tiêu đề">
              <b-form-input v-model.trim="form.title" required />
            </b-form-group>
            <b-form-group label="Slug">
              <b-form-input v-model.trim="form.slug" placeholder="Để trống để tự tạo theo tiêu đề" />
            </b-form-group>
            <b-form-group label="Mô tả ngắn">
              <b-form-textarea v-model.trim="form.summary" rows="3" />
            </b-form-group>
            <b-form-group label="Nội dung">
              <rich-text-editor v-model="form.content" />
            </b-form-group>
          </div>
          <div class="col-lg-4">
            <b-form-group label="Ảnh đại diện">
              <image-uploader v-model="form.thumbnail" />
            </b-form-group>
            <b-form-group label="Thứ tự hiển thị">
              <b-form-input v-model.number="form.displayOrder" type="number" min="1" />
            </b-form-group>
            <b-form-checkbox v-model="form.status" switch class="mb-3">Hiển thị</b-form-checkbox>
            <b-form-checkbox v-model="form.isFeatured" switch class="mb-4">Bài viết nổi bật</b-form-checkbox>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <b-button variant="outline-secondary" class="mr-2" @click="showModal = false">Hủy</b-button>
          <b-button type="submit" variant="primary">{{ editingId ? "Cập nhật" : "Tạo mới" }}</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  fetchAdminPosts,
  createPost,
  updatePost,
  deletePost
} from "../../api/admin";
import RichTextEditor from "../../components/RichTextEditor.vue";
import ImageUploader from "../../components/ImageUploader.vue";
import { isUnauthorizedError } from "../../utils/apiErrors";
import { resolveAssetUrl } from "../../utils/asset";
import { formatDate } from "../../utils/formatters";

function defaultForm() {
  return {
    title: "",
    slug: "",
    thumbnail: "",
    summary: "",
    content: "",
    status: true,
    displayOrder: 1,
    isFeatured: false
  };
}

export default {
  name: "AdminPostsView",
  components: {
    RichTextEditor,
    ImageUploader
  },
  data: function data() {
    return {
      showModal: false,
      editingId: "",
      posts: [],
      form: defaultForm(),
      fields: [
        { key: "thumbnail", label: "Ảnh" },
        { key: "title", label: "Tiêu đề" },
        { key: "status", label: "Trạng thái" },
        { key: "createdAt", label: "Ngày tạo" },
        { key: "displayOrder", label: "Thứ tự" },
        { key: "actions", label: "Thao tác" }
      ]
    };
  },
  created: function created() {
    this.loadPosts();
  },
  methods: {
    resolveAssetUrl,
    formatDate,
    async loadPosts() {
      try {
        const response = await fetchAdminPosts();
        this.posts = response.data;
      } catch (error) {
        if (isUnauthorizedError(error)) return;
        throw error;
      }
    },
    openCreateModal() {
      this.editingId = "";
      this.form = defaultForm();
      this.showModal = true;
    },
    openEditModal(post) {
      this.editingId = post._id;
      this.form = {
        title: post.title,
        slug: post.slug,
        thumbnail: post.thumbnail,
        summary: post.summary,
        content: post.content,
        status: post.status,
        displayOrder: post.displayOrder,
        isFeatured: post.isFeatured
      };
      this.showModal = true;
    },
    async savePost() {
      try {
        if (this.editingId) {
          await updatePost(this.editingId, this.form);
          this.$bvToast.toast("Cập nhật bài viết thành công.", { variant: "success", solid: true });
        } else {
          await createPost(this.form);
          this.$bvToast.toast("Tạo bài viết thành công.", { variant: "success", solid: true });
        }

        this.showModal = false;
        this.form = defaultForm();
        this.loadPosts();
      } catch (error) {
        if (isUnauthorizedError(error)) return;
        throw error;
      }
    },
    async removePost(post) {
      try {
        await deletePost(post._id);
        this.$bvToast.toast("Đã xóa bài viết.", { variant: "success", solid: true });
        this.loadPosts();
      } catch (error) {
        if (isUnauthorizedError(error)) return;
        throw error;
      }
    }
  }
};
</script>

